import type { AuctionEvent } from '@neon-one/auctions-types';

// The one sentence the archived banner shows, keyed by how the auction got
// there: closed on its own and archived afterwards, or archived while it was
// still published or open (closed quietly, nobody told).
export const ARCHIVED_BANNER_COPY = {
  closed: 'Archived. The auction site is offline. Bidders only receive a receipt when you take a payment.',
  closedWithoutSettlement: 'Archived before it closed. Bidders were not notified, invoiced or charged.',
} as const;

export type ArchivedBannerSubject = Pick<AuctionEvent, 'archivedAt' | 'closedWithoutSettlement'>;

export function archivedBannerMessage(event: ArchivedBannerSubject | null | undefined): string | null {
  if (!event?.archivedAt) return null;
  return event.closedWithoutSettlement ? ARCHIVED_BANNER_COPY.closedWithoutSettlement : ARCHIVED_BANNER_COPY.closed;
}

// Every per-auction route carries the auction's uuid as `:id`; routes
// outside an auction carry none, and a catch-all can carry an array.
export function routeAuctionId(param: string | string[] | undefined): string | null {
  return typeof param === 'string' && param !== '' ? param : null;
}
